import React, { useState } from 'react'
import Metatag from '../homepage/Metatag';
import useWindowSize from '../utils/useWindowSize';
import parse from 'html-react-parser';
import Header from '../homepage/Header';
import Footer from '../homepage/Footer';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from 'swiper/modules';
import ReactPlayer from 'react-player';

import './style.css';
import 'swiper/css';

const section2 = [
    {
        title: 'COMMERCIAL',
        text: `<ul>
                        <li>Spectrum mall (OPPOSITE)</li>
                        <li>Noida sector 18 market: (5.2 km)</li>
                        <li>Logix mall wave city centre: (2.3 km)</li>
                        <li>52 Avenue noida & corporate office: (0.18 km) </li>
                        <li>Spectrum metro-PH-2: (300 m)</li>
                        <li>Modi mall: (3.9 km)</li>
                        <li>Adobe office: (3.8 km)</li>
                        <li>Wave mall: (4.9 km)</li>
                        <li>DLF-mall of India: (5.5 km)</li>
                        <li>Kidzania: (5.5 km)</li>
                        <li>Worlds of wonder: (5.5 км)</li>
                    </ul>`,
        image: '/AspireSiliconCity/landmarks.jpg'
    },
    {
        title: 'PSP & RECREATIONAL',
        text: `<ul>
                            <li>Noida golf course: (3.4 km)</li>
                            <li>Noida stadium: (4.1 km)</li>
                            <li>Digamber jain temple: (0.1 km)</li>
                        </ul>`,
        image: '/AspireSiliconCity/recreational.jpg'
    },
    {
        title: 'EDUCATIONAL',
        text: `<ul>
            <li>Kothari international school: (4.2 km)</li>
            <li>Amity university: (4.6 km)</li>
            <li>Manav rachna school: (0.9 km)</li>
            <li>Cambridge school : (4.6 km)</li>
            <li>Army public school:(4 km)</li>
            <li>Nilgiri hills public school : (0.12 km)</li>
            <li>DPS sector 122 noida : (1.5 km)</li>
            <li>Manthan school: (10.7 km) </li>
            </ul>`,
        image: '/AspireSiliconCity/educational.jpg'
    },
    {
        title: 'Healthcare',
        text: `<ul>
        <li>Fortis hospital noida: (5.3 km)</li>
        <li>Medanta hospital (upcoming): (0.45 km)</li>
        <li>Yatharth super-speciality hospital: (2.7 km)</li>
        <li>Apollo hospitals: (4.3 km)</li>
        <li>Vinayak hospital: (4.8 км)</li>
        <li>Kailash hospital: (3.1 km)</li>
        </ul>`,
        image: '/AspireSiliconCity/healthcare.jpg'
    },
    {
        title: 'Nearest metro station',
        text: `<ul>
        <li>Sector-76 noida: (0.02 km)</li>
        <li>Sector-50, noida: (0.03 km)</li>
        </ul>`,
        image: '/AspireSiliconCity/metro.jpg'
    },
    {
        title: 'Nearest airport',
        text: `<ul>
        <li>Indira gandhi international airport via baba banda singh bahadur setu: (28 km)</li>
        <li>Jewar airport via dadri main rd and yamuna expy: (45 km)</li>
        </ul>`,
        image: '/AspireSiliconCity/airport.jpg'
    }
]

function AspireSiliconCity() {

    const [show, setShow] = useState(`${section2[0]?.image}`);
    const [videoPlay1, setVideoPlay1] = useState(null);
    const [videoPlay2, setVideoPlay2] = useState(null);
    const { width } = useWindowSize();

    const handleAccordionClick = (index) => {
        const imagesUrl = section2?.map((element) => {
            return element.image
        })
        setShow(imagesUrl[index]);
    };

    return (
        <>
            <Metatag
                link="aspire-silicon-city"
                title="Aspire Silicon City | AU Real Estate"
                description="Aspire Silicon City | AU Real Estate"
            />
            <Header />
            <section className='banner'>
                <div className='overlay'></div>
                <h2>The Architecture that combines luxury with a sustainable lifestyle</h2>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    loop={true}
                    autoplay={{
                        delay: 8000
                    }}
                    modules={[Navigation, Autoplay]}
                    className="bannerSlider"
                >
                    <SwiperSlide>
                        <img src='/AspireSiliconCity/banner.png' alt='image' />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/banner1.jpg'} alt='image' />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/banner2.jpg'} alt='image' />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/banner3.jpg'} alt='image' />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/banner4.jpg'} alt='image' />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/banner5.jpg'} alt='image' />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/banner6.jpg'} alt='image' />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/banner7.jpg'} alt='image' />
                    </SwiperSlide>
                </Swiper>
            </section>

            <div className='seperator'>
                <img src={'/AspireSiliconCity/seperator.png'} alt='image' />
                <img src={'/AspireSiliconCity/seperator.png'} className='rotate' alt='image' />
            </div>

            <section className='section1'>
                <h2>Biophilic spaces crafted for your well-being</h2>
                <ul>
                    <li>Reduce building footprint</li>
                    <li>Optimize daylight with orientation & placement</li>
                    <li>Strategic built mass placement</li>
                    <li>Shared, centralized amenities</li>
                </ul>
            </section>

            <div className='seperator'>
                <img src={'/AspireSiliconCity/seperator.png'} alt='image' />
                <img src={'/AspireSiliconCity/seperator.png'} className='rotate' alt='image' />
            </div>

            <section className='section2'>
                <h2>Nearby landmarks:</h2>
                <div className='accordionImage'>
                    <div className="accordion" id="accordionExample">
                        <div className="accordion-item" onClick={() => handleAccordionClick(0)}>
                            <h2 className="accordion-header" id={`heading${0}`}>
                                <button className="accordion-button" type="button" data-related-map={`map${0}`} data-bs-toggle="collapse" data-bs-target={`#${'tab' + 0}`} aria-expanded="true" aria-controls={`${'tab' + 0}`}>
                                    {section2[0]?.title}
                                </button>
                            </h2>
                            <div id={`${'tab' + 0}`} className="accordion-collapse collapse show" aria-labelledby={`heading${0}`} data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    {parse(section2[0]?.text)}
                                </div>
                            </div>
                        </div>
                        {section2?.map((element, i) => (
                            i > 0 &&
                            <div key={i} className="accordion-item" onClick={() => handleAccordionClick(i)}>
                                <h2 className="accordion-header" id={`heading${i}`}>
                                    <button className="accordion-button collapsed" type="button" data-related-map={`map${i}`} data-bs-toggle="collapse" data-bs-target={`#${'tab' + i}`} aria-expanded="false" aria-controls={`${'tab' + i}`}>
                                        {element?.title}
                                    </button>
                                </h2>
                                <div id={`${'tab' + i}`} className="accordion-collapse collapse" aria-labelledby={`heading${i}`} data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        {parse(element?.text)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div>
                        <img src={show} alt='image' />
                    </div>
                </div>
            </section>

            <div className='seperator'>
                <img src={'/AspireSiliconCity/seperator.png'} alt='image' />
                <img src={'/AspireSiliconCity/seperator.png'} className='rotate' alt='image' />
            </div>

            <section className='section3'>
                <h3>Amenities</h3>
                <p>Innovation, sustainability and serenity in perfect harmony</p>
                <Swiper
                    className='amenities'
                    loop={true}
                    autoplay={{
                        delay: 4000,
                    }}
                    breakpoints={{
                        0: {
                            slidesPerView: 1.6,
                            spaceBetween: 10,
                        },
                        768: {
                            slidesPerView: 5,
                            spaceBetween: 10
                        },
                        1025: {
                            slidesPerView: 7,
                            spaceBetween: 10
                        }
                    }}
                    modules={[Autoplay]}
                >
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture3.png'} alt='image' />
                        <p>Ground + 4 level club for Biophilic Living</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture4.png'} alt='image' />
                        <p>Exquisite Central landscape</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture5.png'} alt='image' />
                        <p>Jogging Track</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture6.png'} alt='image' />
                        <p>Two Multi-Sports Courts</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture7.png'} alt='image' />
                        <p>Yoga & Meditation Zone</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture8.png'} alt='image' />
                        <p>ZEN Garden</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture19.png'} alt='image' />
                        <p>Elderly Zone</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture10.png'} alt='image' />
                        <p>Open party lawns</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture11.png'} alt='image' />
                        <p>Kids Play area</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture12.png'} alt='image' />
                        <p>Active Pet park</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture13.png'} alt='image' />
                        <p>Rock garden</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture14.png'} alt='image' />
                        <p>Swimming pool</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture15.png'} alt='image' />
                        <p>Sculptures</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture16.png'} alt='image' />
                        <p>Water Fountain & Stream</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture17.png'} alt='image' />
                        <p>Handicap Parking</p>
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={'/AspireSiliconCity/amenities/Picture18.png'} alt='image' />
                        <p>EV Charging zone</p>
                    </SwiperSlide>
                </Swiper>
            </section>

            <div className='seperator'>
                <img src={'/AspireSiliconCity/seperator.png'} alt='image' />
                <img src={'/AspireSiliconCity/seperator.png'} className='rotate' alt='image' />
            </div>

            <section className='section4'>
                <h2>Step into a Greener, Intelligent Future</h2>
                <p>Switch to energy- efficient, environmentally responsive & ecologically balanced homes today</p>
            </section>

            <div className='seperator'>
                <img src={'/AspireSiliconCity/seperator.png'} alt='image' />
                <img src={'/AspireSiliconCity/seperator.png'} className='rotate' alt='image' />
            </div>

            <section className='plans'>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    loop={true}
                    autoplay={{
                        delay: 8000
                    }}
                    autoHeight={true}
                    modules={[Navigation, Autoplay]}
                    navigation={true}
                    className="plansSlider"
                >
                    <SwiperSlide>
                        <h3>Ground Floor Plan</h3>
                        <img src='/AspireSiliconCity/GROUND-FLOOR-PLAN.jpg' alt='image' />
                    </SwiperSlide>
                    <SwiperSlide>
                        <h3>Site Plan</h3>
                        <img src={'/AspireSiliconCity/Aspire-Gardenia.jpg'} alt='image' />
                    </SwiperSlide>
                    <SwiperSlide>
                        <h3>Unit Plan</h3>
                        <img src={'/AspireSiliconCity/3BH-4BHK.jpg'} alt='image' />
                    </SwiperSlide>
                    <SwiperSlide>
                        <h3>Penthouse Unit Plan</h3>
                        <img src={'/AspireSiliconCity/35-PNTHS.jpg'} alt='image' />
                    </SwiperSlide>
                </Swiper>
            </section>

            <div className='seperator'>
                <img src={'/AspireSiliconCity/seperator.png'} alt='image' />
                <img src={'/AspireSiliconCity/seperator.png'} className='rotate' alt='image' />
            </div>

            <section className='Video'>
                <div className='section5left'>
                    <h3>Welcome to Aspire Silicon City by AU</h3>
                    <p>Discover our new benchmark in luxury living with Aspire Silicon City, a premium residential society in the heart of Noida. Step into a world of refined living with luxurious penthouses, thoughtfully designed to provide space, style, and privacy. Aspire Silicon City offers unmatched convenience, 5-star amenities, and a lifestyle that caters to your dreams. Made possible with AU - Building for the way you want to live.</p>
                </div>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    loop={true}
                    // autoplay={{
                    //     delay: 8000
                    // }}
                    navigation={true}
                    modules={[Autoplay, Navigation]}
                    className="videoSlider"
                >
                    <SwiperSlide className='relative'>
                        <div className='overlay' onClick={() => { setVideoPlay1(!videoPlay1); setVideoPlay2(false); }} />
                        <ReactPlayer url={'https://www.youtube.com/watch?v=FxTZfXtfWIs'} className='video' loop muted playing={videoPlay1} />
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className='overlay' onClick={() => { setVideoPlay2(!videoPlay2); setVideoPlay1(false); }} />
                        <ReactPlayer url={'https://youtu.be/yrhgPbAQoQE'} className='video' loop muted playing={videoPlay2} />
                    </SwiperSlide>
                </Swiper>
                {/* <div className='videoNavigation'>
                    <div className=' swiper-button-prev-video'>prev</div>
                    <div className='swiper-button-next-video'>next</div>
                </div> */}
            </section>

            <Footer />
        </>
    )
}

export default AspireSiliconCity